// 增量上传
<template>
    <div class="group">
        <el-row>
            <el-col :span="24">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <i class="el-icon-edit"></i>
                        <span>增量文件上传</span>
                    </div>
                    <div class="search-content mar_b">
                        <el-button type="info" @click="download" size="big">模板下载</el-button>
                    </div>
                    <!-- action="https://zjinsight.vip/seagullpj/params/uploadExcelFile" 
                        action="http://192.168.0.233:8080/chengkaipj/control/uploadExcelFile"
                    -->
                    <div class="search-content mar_b">
                        <el-upload class="upload-demo" 
                                name = "fileList"
                                ref="upload" 
                                action="http://192.168.0.112:8080/ldspj/diamond/uploadExcelFile3"
                                :auto-upload="false" 
                                :data="{user:user}"
                                :multiple="true" 
                                :before-upload="beforeUpload"
                                :on-success="handleSuccess"
                                :on-error="handleError"
                                :on-preview="handlePreview" 
                                :on-remove="handleRemove" >
                            <el-button type="primary" slot="trigger" size="big">选取文件</el-button>
                            <el-button type="success" @click="submitUpload" size="big">增量上传</el-button>
                            <div slot="tip" class="el-upload__tip" style="font-size:20px">只能上传xls/xlsx格式的文件</div>
                        </el-upload>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    import util from '../../common/js/util';
    import axios from 'axios/index';
    import config_1 from '../../common/js/config.js';
    import cookieOperation from '../../common/js/cookieOperation';
    export default {
        data() {
            return {
                fileList: [],
                user:'admin',
                companyList: {
                    company_code: '',
                    company_name: '',
                }
                // userInfoAllList:[],
                // uploadForm : new FormData(),
            };
        },
        methods: {
            handleSuccess(res, file){
                if(res.flag){
                    this.successMsg('上传成功');
                }else{
                    this.errorMsg('上传失败');
                }
                console.log(res);
            },
            handleError(res, file){
                this.errorMsg('上传失败');
                console.log(res);
                if ("502" == res.code) {
                    this.$router.push('/login');
                }
            },
            handlePreview(file) {
                console.log(file);
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            beforeUpload(file) {
                const extension = file.name.split(".")[1] === "xls";
                const extension2 = file.name.split(".")[1] === "xlsx";
                if (!extension && !extension2) {
                    alert('上传附件只能是xls/xlsx格式！');
                    return false;
                }
            },
            submitUpload() {
                // 第一种上传 ref
                this.$refs.upload.submit();
                this.fileList = [];
            },
            // 模板下载
            download() {
                window.location.href = '/download/钻石数据增量上传模板.xlsx';
            },
        },
        mounted() {
            this.user = sessionStorage.getItem('userName');
        }
    };
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/diamond/fileIncrementUpload.vue